var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayContent)?_c('div',{staticClass:"d-block"},[(_vm.useVIf)?[(_vm.isActive)?_c('div',{staticClass:"tab__item__content__wrapper"},[_vm._t("default")],2):_vm._e()]:[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"tab__item__content__wrapper"},[_vm._t("default")],2)]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }